import Image from "next/image";

const BlogBanner = () => {
    return (
        <div className="relative">
            <Image
                src="/images/blog_banner.webp"
                alt="blog"
                width={0}
                height={0}
                sizes="100vw"
                className="w-full"
                priority={true}
            />
           
       
        </div>
    );
};
export default BlogBanner;
